import { useSelector } from "react-redux";
import { message } from 'antd';
import md5 from 'js-md5';
import OSS from 'ali-oss';
import SparkMD5 from 'spark-md5';
import { getOssToken } from '@/utils/api/common';
import { hideLoading, showLoading } from '@/utils/loading';

export const STATIC_RESOURCE = 'https://fe-ifarm.cpgroupcloud.com/static_resource';
// 扫描全部文件
export function importAll() {
  const r = require.context('/src', true, /language.js$/);

  return r.keys().reduce((pre, next) => {
    const key = next.replace('./', '').replace('.js', '').split('/').join('.');
    !pre[key] ? (pre[key] = r(next)) : (pre[key] = { ...pre[key], ...r(next) });
    return pre;
  }, {});
};

// const a = () => {
//   const r = require.context('/src', true, /.js$/);
//   return r.keys().filter(item => !['util', 'constant', 'reducers', 'language', 'api'].find(c => item.includes(c)));
// };

// console.log(JSON.stringify(a(), null, 2));

// 中英切换（即将废弃）
export function Translate(language_type) {
  const translate_json = useSelector(state => state.cache.cache)[language_type].language;
  const language = useSelector(state => state.lang.value);
  return translate_json?.[language] || {};
};

//语言切换
export function translateBase({ translate_language_key, key, store }) {
  return store?.cache?.cache?.[translate_language_key]?.language?.[store?.lang?.value]?.[key];
}

//路由处理
export const format_routes = (data) => {
  return data.flatMap(item => [
    { ...item, children: undefined },
    ...(item.children ? format_routes(item.children) : [])
  ]);
};

// 生成唯一id
// 指定长度和基数
export function guid() {
  try {
    return crypto?.randomUUID?.();
  } catch (error) {
    const blobUrl = URL.createObjectURL(new Blob());
    URL.revokeObjectURL(blobUrl);
    return blobUrl.slice(blobUrl.lastIndexOf('/') + 1);
  }
}

//截取制定长度的数组
export function chunk(array, size = 1) {
  return Array.from({ length: Math.ceil(array.length / size) }, (_, i) => array.slice(i * size, (i + 1) * size));
}


export function getSupplierIdentity() { //供应商
  const local_storage_company_info = localStorage.getItem('company_info' || '{}');
  const storage_company_info = local_storage_company_info ? JSON.parse(local_storage_company_info) : {};
  if (Reflect.ownKeys(storage_company_info).length) {
    const { company_role, supplier_is_examine } = storage_company_info;
    const computed_company_role = company_role & 1;

    if (computed_company_role === 0 && supplier_is_examine === 2) {
      return 1; // 未申请供应商
    }
    if (computed_company_role === 0 && [1, 4].includes(supplier_is_examine)) {
      return 2; // 已申请供应商-待审核
    }
    if (computed_company_role === 0 && supplier_is_examine === 3) {
      return 3; //已申请供应商-审核未通过
    }
    if (computed_company_role === 1) {
      return 4;//正式供应商
    }
  } else {
    return 0;
  }
  return 0;
};

export function getPurchaserIdentity() {//采购商
  const local_storage_company_info = localStorage.getItem('company_info' || '{}');
  const storage_company_info = local_storage_company_info ? JSON.parse(local_storage_company_info) : {};
  if (Reflect.ownKeys(storage_company_info).length) {
    const { company_role } = storage_company_info;
    const computed_company_role = company_role & 2;
    if (computed_company_role) {
      return 1;
    }
    return 0;
  } else {
    return 0;
  }
};

const IntlNumberFormat = ({ number, maximumFractionDigits, minimumFractionDigits = 2 }) => new Intl.NumberFormat(undefined, { minimumFractionDigits, maximumFractionDigits }).format(number);

export const numberFormat = ({ number = 0, maximumFractionDigits = 4, minimumFractionDigits = 2 }) => {
  const min_decimal_number = 0.0001;
  const computed_number = parseFloat(number);
  if (computed_number === 0) {
    return IntlNumberFormat({ number, minimumFractionDigits });
  } else {
    const sign_number = Math.sign(computed_number);
    if (sign_number > 0) {
      return IntlNumberFormat({ number: number < min_decimal_number ? min_decimal_number : number, maximumFractionDigits, minimumFractionDigits });
    } else {
      return IntlNumberFormat({ number: number > min_decimal_number * sign_number ? min_decimal_number * sign_number : number, maximumFractionDigits, minimumFractionDigits });
    }
  }
};

export const sliceString = (path, len = 3) => path.split('/').slice(0, len).join('/');
export const pathSliceMatch = (path) => {
  return path.split('/').filter(item => !/\d/.test(`${item}`)).join('/').replace(/\/:.*/ig, '');
};

/**
 *
 * @param {
* 此方法为最新的货币相关的计算公式，下方方法在新版本迭代中逐渐淘汰
*
*  入参
*  currencyList 汇率列表
*  defaultCurrency 默认币种
*  currentCurrency 当前币种
*  number 待格式化的数据
*
*  返回值：（可根据情况自由组合）
*  currency 货币名称
*  currencySymbol 货币符号
*  currencyNumber 保留小数统一规则
*  exchangeRate 汇率
*  currencyRateNumber 按照汇率计算后的结果（统一币种汇率为1）
*  currencySymbolNumber 货币符号+按照汇率计算后的结果（统一币种汇率为1）
*
* } params
*/

export function formatCurrencyNumber(params = {}) {
  const { currencyList = [], defaultCurrency = 'CNY', currentCurrency = 'CNY', number = 0 } = params;
  const { exchange_rate = {}, currency_symbol: currencySymbol = '', currency } = currencyList.find(item => item.currency_en === currentCurrency) || { exchange_rate: {}, currency_symbol: '' };
  const exchangeRateKey = `${defaultCurrency}${currentCurrency}`;
  const exchangeRate = exchange_rate[exchangeRateKey] || 1;
  const currencyRateNumber = exchangeRate * number;
  const currencyNumber = numberFormat({ number: currencyRateNumber });
  const currencySymbolNumber = `${currencySymbol}${currencyNumber}`;
  return { currencySymbol, currencyNumber, currencySymbolNumber, currencyRateNumber, exchangeRate, currency };
};

export function getCurrencyAndSymbol({ currentCurrency = 'CNY', currencyList = [] }) {
  const { currency_symbol = '¥', currency } = currencyList.find(item => item.currency_en === currentCurrency) || { currency_symbol: '¥' };
  return { currency, currency_symbol };
};

export const createPDF = async (data = {}) => {
  showLoading();
  const response = await fetch(`https://tool-html2any.cpgroupcloud.com/html2any/generatePDF`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ width: 1440, height: 1080, ...data }), });
  const blob = await response.blob();
  baseDownLoad({ blob, name: data.fileName });
  hideLoading();
};

export const baseDownLoad = ({ blob, name }) => {
  const url = window.URL.createObjectURL(blob);
  const Ele = document.createElement('a');
  Ele.href = url;
  Ele.download = name;
  Ele.click();
  window.URL.revokeObjectURL(url);
};

export async function ossToken() {
  const { data: { code, data } } = await getOssToken();
  return new Promise(resolve => {
    if (+code === 0) {
      return resolve(data);
    }
  });
};

function getFileMd5BySlice(file, random) {
  return new Promise((resolve) => {
    const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice, chunkSize = 1024 * 1024, chunks = Math.ceil(file.size / chunkSize), spark = new SparkMD5.ArrayBuffer(), fileReader = new FileReader();
    let currentChunk = 0;
    fileReader.onload = function (e) {
      spark.append(e.target.result);
      currentChunk++;
      currentChunk < chunks ? loadNext() : resolve(random ? md5(`${spark.end()}${guid()}`) : spark.end());
    };

    fileReader.onerror = function () {
      resolve(`${md5(file + guid(), chunkSize)}`);
    };
    function loadNext() {
      const start = currentChunk * chunkSize, end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }

    loadNext();
  });
};

export const uploadBase = (currentFile, random = true) => {
  showLoading();
  return new Promise(async resolve => {
    try {
      const { SecurityToken, AccessKeyId, AccessKeySecret } = await ossToken();
      const client = new OSS({ region: 'oss-cn-beijing', accessKeyId: AccessKeyId, accessKeySecret: AccessKeySecret, stsToken: SecurityToken, refreshSTSTokenInterval: 300000, bucket: 'cp-cpmart-dev' });
      const { file, file: { name, uid } } = currentFile;
      const ext = name.substring(name.lastIndexOf('.'));
      const fileMd5 = `${await getFileMd5BySlice(file, random)}${ext}`;
      let { url } = await client.put(fileMd5, file);
      url = url.replace('http:', 'https:');
      resolve({ uid, name, status: 'done', url, thumbUrl: url, url_name: name, md5Name: `${fileMd5}`, img_url: url });
    } catch (error) {
      message.error("上传失败");
    } finally {
      hideLoading();
    }
  });
};

export async function downLoad({ url, name }) {
  try {
    const data = await fetch(url);
    const isJson = data.headers.get("Content-Type")?.includes?.("application/json");
    if (isJson) {
      const { msg } = await data.json();
      message.error(msg);
    } else {
      const blob = await data.blob();
      baseDownLoad({ blob, name });
    }
  } catch (error) {
    console.log('🚀 ~ downLoad ~ error:', error);
  }
};

export function string2decimal(string_number = '') {
  const formateNumber = `${string_number}`.replace(/[^\d|^.|^-]/g, '');
  const formateNumberResult = formateNumber.includes('-') ? '-' + formateNumber.replace(/-/ig, '') : formateNumber;
  return formateNumberResult ? `${parseFloat(formateNumberResult)}` : '';
};

export function getItem(label, key, icon, children, type) {
  return { key, icon, children, label, type, title: label };
};

//菜单权限处理
export const format_route = ({ routes = [], menusList = [], $t = label => label }) => {
  return routes.filter(item => !item.hidden).filter(item => menusList.find(s => s.key === item.key)).map(item => {
    const { label, key, path, children = [] } = item;
    const format_route_children = children.length ? format_route({ routes: children, menusList, $t }) : '';
    return getItem($t(label), key, '', format_route_children, path);
  });
};

//自定义toFixed
export const toFixed = (number, length) => {
  return Math.round(number * Math.pow(10, length)) / Math.pow(10, length);
};

// 排序方式：3-倒序 4-正序
export const ascendConfig = { ascend: 4, descend: 3 };

//格式化排序给后端
export function formatSortParamsToSever(sortParams = {}) {
  return Reflect.ownKeys(sortParams).filter(item => !item.includes('_sorter')).reduce((pre, cur) => ({ ...pre, [cur]: sortParams[cur] }), {});
};

//格式化表格排序
export function formatTableSortParams(sorter, customFlag = '_sorter') {
  return (Array.isArray(sorter) ? sorter : [sorter]).filter(item => item.order).reduce((acc, cur, index) => ({ ...acc, [cur.field]: { sort: ascendConfig?.[cur.order], index }, [`${cur.columnKey}${customFlag}`]: cur.order }), {});
};
//数组对象过滤
export function formatFilterArray(arr = [], key) {
  const map = new Map();
  for (const item of arr) {
    if (!map.has(item[key])) {
      map.set(item[key], item);
    };
  };
  return [...map.values()];
};

export function formatTreeData(data) {
  const newData = [];
  for (const item of data) {
    newData.push({ value: `${guid()}&${item.key}-${item.value}`, title: item.name, children: formatTreeData(item.items) });
  }
  return newData;
};

// 获取文件拓展名
export const getExtName = (url = '') => url.split('?')[0].split('.').pop().toLowerCase();


// 判断数组含有某一组值
export function hasGroupInArray(arr, group) {
  return group.every(item => arr.includes(item));
}

//数组交集
export function intersection(arr1, arr2) {
  return arr1.filter(item => arr2.includes(item));
}

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function urlToStandard(url) {
  return url?.split('/').slice(3).join('/').replace(/([-/])(.)/g, (_, symbol, char) => char.toUpperCase());
};

export function getAllParams(url = window.location.search) {
  return Object.fromEntries((new URLSearchParams(url)).entries());
}


export function clearExcept() {
  Array.from({ length: localStorage.length }, (_, i) => localStorage.key(i)).filter(item => !item.includes('invite_id')).map(item => localStorage.removeItem(item));
}